/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Order_Lot_Trace_Virtual_TabInputs */

const vi_order_lot_trace_virtual_tab = /** @type {(inputs: Order_Lot_Trace_Virtual_TabInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} — đang nợ`)
};

/**

* @param {Order_Lot_Trace_Virtual_TabInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_virtual_tab = /** @type {((inputs: Order_Lot_Trace_Virtual_TabInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Virtual_TabInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_virtual_tab(inputs)
});